import { EditCompanyBigLogoOutDto, EditCompanyBigLogoInDto } from '../../../types/company.dto'

export const EDIT_COMPANY_BIG_LOGO = 'EDIT_COMPANY_BIG_LOGO'
export const EDIT_COMPANY_BIG_LOGO_SUCCESS = 'EDIT_COMPANY_BIG_LOGO_SUCCESS'
export const EDIT_COMPANY_BIG_LOGO_ERROR = 'EDIT_COMPANY_BIG_LOGO_ERROR'
export const RESET_EDIT_COMPANY_BIG_LOGO = 'RESET_EDIT_COMPANY_BIG_LOGO'

export interface EditCompanyBigLogo {
  type: typeof EDIT_COMPANY_BIG_LOGO
  payload: EditCompanyBigLogoOutDto
}

export interface EditCompanyBigLogoSuccess {
  type: typeof EDIT_COMPANY_BIG_LOGO_SUCCESS
  payload: EditCompanyBigLogoInDto
}

export interface EditCompanyBigLogoError {
  type: typeof EDIT_COMPANY_BIG_LOGO_ERROR
  payload: string | boolean
}

export interface ResetEditCompanyBigLogo {
  type: typeof RESET_EDIT_COMPANY_BIG_LOGO
  payload: null
}
export interface State {
  data: EditCompanyBigLogoInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditCompanyBigLogo | EditCompanyBigLogoSuccess | EditCompanyBigLogoError | ResetEditCompanyBigLogo
